import React, { useState } from "react";
import SearchOptions from "./SearchOptions";

export default ({ search, updateParentState, searchParameters, ...props }) => {
  const [searchValue, setSearchValue] = useState("");

  const updateSearchText = (e) => {
    let searchCode = e.target.value;
    setSearchValue(searchCode);
    updateParentState({
      searchParameters: { ...searchParameters, searchCode },
      searchText: searchCode,
    });
  };

  const { IsEnablePhysicalSearch, IsEnableDigitalSearch, Options, _ } = props;

  return (
    <>
      <div className="storage-search-input search-input rounded-shadow input-group">
        <input
          id="searchTerm"
          type="text"
          className="form-control"
          placeholder="Search for stored items"
          value={searchValue}
          onChange={(e) => updateSearchText(e)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              search();
            }
          }}
        />
        <i className="icon-omni-search" onClick={() => search()}></i>
      </div>

      {IsEnablePhysicalSearch && IsEnableDigitalSearch && (
        <SearchOptions
          options={Options}
          updateParentState={updateParentState}
          _={_}
        ></SearchOptions>
      )}
    </>
  );
};
